import Echo from 'laravel-echo'
window.io = require('socket.io-client')

export default function initEcho(superadmin = false) {
    // const host = useProxy ?
    //     'https://proxyapi.dentist-plus.com:6002'
    //     : (process.env.VUE_APP_LARAVEL_ECHO_DOMAIN || process.env.VUE_APP_API_DOMAIN + ':6001')
    // console.log(useProxy)
    const host = (process.env.VUE_APP_LARAVEL_ECHO_DOMAIN || process.env.VUE_APP_API_DOMAIN + ':6001')
        // : process.env.VUE_APP_API_DOMAIN + ':6001'
    const options = {
        broadcaster: "socket.io",
        host,
        auth: {
            headers: {
                Authorization: 'Bearer ',
                'X-Dev-Frontend': process.env.VUE_APP_TEST_ECHO ? '1' : '0',
            }
        }
    }
    if(superadmin) {
        options.auth.headers.superadmin = 'superadmin'
    }
    return new Echo(options)
}
